/* =========================
   TOGGLE TAB
========================= */

if ( typeof ToggleTab !== 'function' ) {

  class ToggleTab extends HTMLElement {

    constructor(){
      super();

      this.titleEl = this.querySelector('[data-js-title]');
      this.contentEl = this.querySelector('[data-js-content]');

      // Icon append (como estaba)
      if (this.titleEl) {
        this.titleEl.innerHTML = `${this.titleEl.innerHTML}${this.hasAttribute('data-togglepack-alternate')
          ? KROWN.settings.symbols.toggle_pack_alternate
          : KROWN.settings.symbols.toggle_pack}`;
      }

      if ( this.hasAttribute('data-toggle-inert') ) {
        this.toggleInert = true;
      }

      this.titleEl?.addEventListener('click', this.onClickHandler.bind(this));
      this.titleEl?.addEventListener('keydown', e => {
        if ( e.keyCode == window.KEYCODES.RETURN ) {
          this.onClickHandler();
        }
      });
    }

    onClickHandler(){
      if ( !this.classList.contains('opened') ) {
        this.classList.add('opened');
        this.titleEl?.setAttribute('aria-expanded', 'true');
        this.slideDown(this.contentEl, 200);

        if ( this.toggleInert ) {
          this.contentEl?.removeAttribute('inert');
        }

        setTimeout(() => {
          this.contentEl?.querySelector('css-slider')?.resetSlider();
        }, 200);

      } else {
        this.classList.remove('opened');
        this.titleEl?.setAttribute('aria-expanded', 'false');

        if ( this.toggleInert ) {
          this.contentEl?.setAttribute('inert', '');
        }

        this.slideUp(this.contentEl, 200);
      }
    }

    // ✅ Abrir SIN animación (estado inicial)
    openNoAnimation(){
      this.titleEl = this.titleEl || this.querySelector('[data-js-title]');
      this.contentEl = this.contentEl || this.querySelector('[data-js-content]');

      if (!this.titleEl || !this.contentEl) return;

      this.classList.add('opened');
      this.titleEl.setAttribute('aria-expanded', 'true');

      if (this.toggleInert) {
        this.contentEl.removeAttribute('inert');
      }

      // Pisa el CSS que tiene display:none
      this.contentEl.style.display = 'block';

      // Limpia cualquier transición/prop de slide anterior
      this.contentEl.style.removeProperty('height');
      this.contentEl.style.removeProperty('overflow');
      this.contentEl.style.removeProperty('transition-duration');
      this.contentEl.style.removeProperty('transition-property');
      this.contentEl.style.removeProperty('padding-top');
      this.contentEl.style.removeProperty('padding-bottom');
      this.contentEl.style.removeProperty('margin-top');
      this.contentEl.style.removeProperty('margin-bottom');
    }

    slideUp(target, duration){
      if (!target) return;

      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;

      setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }

    slideDown(target, duration) {
      if (!target) return;

      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none') display = 'block';

      target.style.display = display;

      const height = target.offsetHeight;

      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;

      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');

      setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }

  }

  if ( typeof customElements.get('toggle-tab') === 'undefined' ) {
    customElements.define('toggle-tab', ToggleTab);
  }
}

/* =========================
   TOGGLE GROUP (ACCORDION)
========================= */

if ( typeof ToggleGroup !== 'function' ) {

  class ToggleGroup extends HTMLElement {

    constructor(){
      super();

      // Acordeón: cuando abrís uno, cierra los demás
      this.querySelectorAll('toggle-tab').forEach(allToggle => {
        allToggle.querySelector('[data-js-title]')?.addEventListener('click', () => {
          this.querySelectorAll('toggle-tab.opened').forEach(openedToggle => {
            if (allToggle !== openedToggle) {
              openedToggle.onClickHandler();
            }
          });
        });
      });
    }

  }

  if ( typeof customElements.get('toggle-group') === 'undefined' ) {
    customElements.define('toggle-group', ToggleGroup);
  }
}

/* =========================
   ✅ DEFAULT: FIRST OPENED (NO ANIMATION)
   - Corre SIEMPRE, aunque ToggleGroup ya exista en otro archivo
========================= */

(() => {
  const openFirstNoAnimationEverywhere = () => {
    // Caso normal: hay toggle-group
    const groups = document.querySelectorAll('toggle-group');

    if (groups.length) {
      groups.forEach(group => {
        if (group.querySelector('toggle-tab.opened')) return;

        const first = group.querySelector('toggle-tab');
        if (!first) return;

        // si existe openNoAnimation (nuestra clase), úsalo
        if (typeof first.openNoAnimation === 'function') {
          first.openNoAnimation();
        } else {
          // fallback si el theme define otra clase: forzamos estado visual igual
          const titleEl = first.querySelector('[data-js-title]');
          const contentEl = first.querySelector('[data-js-content]');
          first.classList.add('opened');
          titleEl?.setAttribute('aria-expanded', 'true');
          if (contentEl) contentEl.style.display = 'block';
        }
      });
      return;
    }

    // Caso fallback: no hay toggle-group, abrimos el primer toggle-tab global
    const first = document.querySelector('toggle-tab');
    if (!first || first.classList.contains('opened')) return;

    if (typeof first.openNoAnimation === 'function') {
      first.openNoAnimation();
    } else {
      const titleEl = first.querySelector('[data-js-title]');
      const contentEl = first.querySelector('[data-js-content]');
      first.classList.add('opened');
      titleEl?.setAttribute('aria-expanded', 'true');
      if (contentEl) contentEl.style.display = 'block';
    }
  };

  const run = () => requestAnimationFrame(() => requestAnimationFrame(openFirstNoAnimationEverywhere));

  if (customElements?.whenDefined) {
    customElements.whenDefined('toggle-tab').then(run);
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
